import Head from 'next/head'

interface Author {
  name: string
  path: string
}

interface NewsPageProps {
  title: string
  dateModified?: string
  datePublished?: string
  author?: Author[]
}

export function RichSnippetNewsPage({
  title,
  dateModified,
  datePublished,
  author
}: NewsPageProps) {
  const schemaNewsPage = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: title
  } as any

  if (dateModified) {
    schemaNewsPage.dateModified = dateModified
  }

  if (datePublished) {
    schemaNewsPage.datePublished = datePublished
  }

  if (author) {
    schemaNewsPage.author = author.map(author => ({
      '@type': 'Person',
      name: author.name,
      path: author.path
    }))
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaNewsPage)
        }}
      />
    </Head>
  )
}
